module.exports = __webpack_public_path__ + "media/images/aloe/icons/demo/elements/selects-0be125001998ceaf72367acef99bc80d.svg";